/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { Box } from '@mui/material';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { intl } from '../../helper/IntlGlobalProvider';
import { StreamSheetAppBar } from '../StreamSheetAppBar';
import StreamSheetNavigation from '../StreamSheetNavigation';
import ServerStatusDialog from '../utils/ServerStatusDialog';
import StreamSheetBreadCrumbs from '../utils/StreamSheetBreadCrumbs';
import { toHashObject } from '../utils/URLHash';

function LoadingPageComponent() {
	const navigate = useNavigate();
	const [showViewMode] = useState(
		window.location.href.indexOf('preview') !== -1 || toHashObject(window.location.hash).preview || false
	);

	document.title = intl.formatMessage({ id: 'TabTitle.Loading' }, {});
	const drawerWidth = showViewMode ? 0 : 60;

	return (
		<div style={{ width: 'inherit', height: 'inherit' }}>
			{showViewMode ? null : (
				<div>
					<StreamSheetAppBar />
					<StreamSheetNavigation appLoadingDisabled openPage={navigate} />
				</div>
			)}
			<Box
				sx={{
					position: 'relative',
					height: `calc(100% - ${showViewMode ? 0 : 50}px)`,
					width: `calc(100% - ${drawerWidth}px)`,
					marginLeft: `${drawerWidth}px`,
					overflow: 'hidden',
					bgcolor: (theme) => theme.wall.backgroundColor
				}}
			>
				{showViewMode ? (
					<ServerStatusDialog open />
				) : (
					[
						<StreamSheetBreadCrumbs key="crumbs" path="Home/Apps/Loading" openPage={navigate} />,
						<Box
							key="paper"
							elevation={1}
							sx={{
								marginRight: 'auto',
								marginLeft: 'auto',
								margin: '10px 15px 15px 15px',
								height: 'calc(100% - 60px)'
							}}
						>
							<div
								style={{
									margin: '5px',
									height: '100%',
									padding: '20px'
								}}
							>
								<ServerStatusDialog open />
							</div>
						</Box>
					]
				)}
			</Box>
		</div>
	);
}

export const LoadingPage = injectIntl(LoadingPageComponent);
